<script setup>
import { municipalityList } from '@/client'
import { useLohndatenStore } from '@/stores/lohndaten'
import { inject } from 'vue'

import { client } from '@/lohnrechner'

const store = useLohndatenStore()
const emit = defineEmits(['complete'])
const t = inject('t')

async function searchPLZ(query) {
  return new Promise((resolve) => {
    municipalityList({
      query: { search: query ? query : '', id: store.onrp ? store.onrp : null },
      client: client
    }).then((list) => {
      resolve(list.data.results.map((m) => ({ value: m.pk, label: m.plz + ' ' + m.name })))
    })
  })
}

function onClear() {
  store.onrp = null
}

function onSelect(option) {
  store.onrp = option
  emit('complete')
}
</script>
<template>
  <SelectElement :default="store.onrp" :no-options-text="t('plz-ort-hint')" :delay="100" :filter-results="false"
    :label="t('plz')" :native="false" name="plz" :rules="['required']" :placeholder="t('ort-frage')" :search="true"
    autocomplete="off" :can-clear="true" :items="searchPLZ" @select="onSelect" @clear="onClear">
  </SelectElement>
</template>
